var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:{'donetask': _vm.isDone}},[_c('input',{attrs:{"type":"checkbox"},on:{"cnange":_vm.change}}),_c('label',[_vm._v(_vm._s(_vm.task.name))]),_c('button',{staticClass:"btnRemove",on:{"click":_vm.remove}},[_vm._v("Remove")])])}
var staticRenderFns = []

export { render, staticRenderFns }